import clsx from 'clsx';
import * as React from 'react';
import type { SeparatorProps as RACSeparatorProps } from 'react-aria-components';
import { Separator as RACSeparator } from 'react-aria-components';

interface DividerProps {
    // TODO: Support all divider kinds
    label?: string;

    className?: string;
}

export const Separator = React.forwardRef(function Separator(
    props: RACSeparatorProps,
    ref: React.ForwardedRef<HTMLDivElement>
) {
    return (
        <RACSeparator
            ref={ref}
            {...props}
            className={clsx(
                props.orientation === 'vertical' ? 'h-full border-l' : 'w-full border-t',
                props.className
            )}
        />
    );
});

export function Divider(props: DividerProps) {
    return (
        <div
            className={clsx(
                'my-0.5 grid w-full [grid-template-columns:1fr] [grid-template-rows:1fr]',
                props.className
            )}
        >
            <Separator className="my-0 w-full place-self-center [grid-area:1/1]" />
            {props.label ? (
                <span className="z-[1] place-self-center bg-base px-2 text-muted text-ui-heading-group [grid-area:1/1] [text-box:trim-both_cap_alphabetic]">
                    {props.label}
                </span>
            ) : null}
        </div>
    );
}
